"use client"

import { Analytics } from "@vercel/analytics/next"
import { createVercelAnalyticsFilter } from "@/lib/vercel-analytics-filter"

const beforeSend = createVercelAnalyticsFilter()

/**
 * Vercel Web Analytics tracker. Keep this mounted from `app/layout.tsx`
 * (not a preview-only or host-gated branch) so production pageviews hit
 * `/_vercel/insights/view`. `beforeSend` drops automated and looping traffic
 * before it is billed; see lib/vercel-analytics-filter.ts.
 */
export function VercelAnalytics() {
  return <Analytics beforeSend={beforeSend} />
}
